import Service from "../../services";

const state = {
  personalInfo: {
    profile_id: null,
    name_th: "",
    last_th: "",
    city: "",
    brand_name: "",
    profession: "",
    design_type: "",
    email: "",
    mobile_number: "",
    website: "",
    domain_name: "",
    facebook: "",
    instagram: "",
    pinterest: "",
    educations: [
      { id: 1, school_university: null, degree: null, class_of: null },
    ],
    works: [{ id: 1, company: null, position: null, city: null }],
    mem_info: {
      avatar: null,
      cover_url: null,
      bio: "",
      location: "",
      brand_name: "",
      profession: "",
      design_type: "",
      website: "",
      domain_name: "",
      facebook: "",
      instagram: "",
      pinterest: "",
      twitter: "",
    },
  },
};

const getters = {};

const actions = {
  onGetProfileInfo({ commit }, id) {
    return Service.profile.getProfileInfo(id).then((res) => {
      commit("setPersonalInfo", res);
      return res;
    });
  },

  onGetProfile({ commit }, id) {
    return Service.profile.getProfileInfo(id).then((res) => {
      return res;
    });
  },

  onCreateProfileInfo({ commit }, data) {
    return Service.profile.createProfileInfo(data).then((res) => {
      if (res.status === "update profile success") {
        // this.$swal({
        //     icon: 'success',
        //     title: 'Create profile successful!',
        //     confirmButtonColor: '#FD5246',
        //     confirmButtonText: 'ตกลง',
        // });
        alert("Create profile successful!");
        return res;
      }
    });
  },

  onUpdateProfileInfo({ commit }, data) {
    return Service.profile.updateProfileInfo(data).then((res) => {
      if (res === "success") {
        // alert("Update profile successful!");
        return res;
      }
    });
  },

  onUploadImage({ commit }, data) {
    let param = new FormData();
    param.append("file", data.image);
    param.append("type", data.type);
    return Service.image.uploadImageMember(param).then((res) => {
      if (res.status === 200) {
        if (data.type === "profile") {
          commit("setProfilePicture", res.data);
        } else if (data.type === "cover") {
          commit("setCoverPicture", res.data);
        }
      }
    });
  },

  clearPersonalInfo({ commit }) {
    commit("CLEAR_DATA");
  },
};

const mutations = {
  CLEAR_DATA(state) {
    state.personalInfo = {
      profile_id: null,
      name_th: "",
      last_th: "",
      city: "",
      brand_name: "",
      profession: "",
      design_type: "",
      email: "",
      mobile_number: "",
      website: "",
      domain_name: "",
      facebook: "",
      instagram: "",
      pinterest: "",
      educations: [
        { id: 1, school_university: null, degree: null, class_of: null },
      ],
      works: [{ id: 1, company: null, position: null, city: null }],
      mem_info: {
        avatar: null,
        cover_url: null,
        location: "",
        brand_name: "",
        profession: "",
        design_type: "",
        website: "",
        domain_name: "",
        facebook: "",
        instagram: "",
        pinterest: "",
        twitter: "",
      },
    };
  },
  setPersonalInfo(state, data) {
    state.personalInfo = data;

    if (state.personalInfo.mem_info == null) {
      state.personalInfo.mem_info = {
        avatar: null,
        cover_url: null,
        location: "",
        brand_name: "",
        profession: "",
        design_type: "",
        website: "",
        domain_name: "",
        facebook: "",
        instagram: "",
        pinterest: "",
        twitter: "",
      };
    }

    if (state.personalInfo.educations) {
      if (state.personalInfo.educations.length > 0) {
        state.personalInfo.educations.forEach((item, i) => {
          item.id = i + 1;
        });
      }
    }
    if (state.personalInfo.works) {
      if (state.personalInfo.works.length > 0) {
        state.personalInfo.works.forEach((item, i) => {
          item.id = i + 1;
        });
      }
    }
  },

  addEducationInfo(state) {
    if (state.personalInfo.educations.length <= 0) {
      state.personalInfo.educations.push({
        id: 1,
        school_university: null,
        degree: null,
        class_of: null,
      });
    } else {
      let lastId =
        state.personalInfo.educations[state.personalInfo.educations.length - 1]
          .id;
      state.personalInfo.educations.push({
        id: lastId + 1,
        school_university: null,
        degree: null,
        class_of: null,
      });
    }
  },
  removeEducationInfo(state, id) {
    state.personalInfo.educations = state.personalInfo.educations.filter(
      (item) => {
        if (item.id !== id) {
          return item;
        }
      }
    );
  },

  addWorkExperience(state) {
    if (state.personalInfo.works.length <= 0) {
      state.personalInfo.works.push({
        id: 1,
        company: null,
        position: null,
        city: null,
      });
    } else {
      let lastId =
        state.personalInfo.works[state.personalInfo.works.length - 1].id;
      state.personalInfo.works.push({
        id: lastId + 1,
        company: null,
        position: null,
        city: null,
      });
    }
  },
  removeWorkExperience(state, id) {
    state.personalInfo.works = state.personalInfo.works.filter((item) => {
      if (item.id !== id) {
        return item;
      }
    });
  },

  resetPersonalInfo(state) {
    state.personalInfo = {
      educations: [
        { id: 1, school_university: null, degree: null, class_of: null },
      ],
      works: [{ id: 1, company: null, position: null, city: null }],
    };
  },

  setProfilePicture(state, data) {
    state.personalInfo.mem_info.avatar = data;
  },

  setCoverPicture(state, data) {
    state.personalInfo.mem_info.cover_url = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
